module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "pricing-table section-padding",
    staticStyle: {
      "padding-top": "80px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Contact us")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-table text-center mb-4 mb-md-0"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("Venue Address")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-group"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("5 Caldwell Street Mount Gambier 5290 ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Next to Forty Winks")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-table text-center"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("Contact Venue")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("📞 0466900048")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d1b6b1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ContactUs.vue
// module id = 241
// module chunks = 1